// FETCH ALL PROPERTIES FROM ROLES
export const FETCH_ROLES_REQUEST = 'FETCH_ROLES_REQUEST';
export const FETCH_ROLES_SUCCESS = 'FETCH_ROLES_SUCCESS';
export const FETCH_ROLES_FAILURE = 'FETCH_ROLES_FAILURE';

// CREATE PROPERTIES FOR ROLES
export const CREATE_ROLES_REQUEST = 'CREATE_ROLES_REQUEST';
export const CREATE_ROLES_SUCCESS = 'CREATE_ROLES_SUCCESS';
export const CREATE_ROLES_FAILURE = 'CREATE_ROLES_FAILURE';

//CREATE USER FORM
export const CREATE_USER_FORM_ROLES = 'CREATE_USER_FORM_ROLES';
//CREATE CHECKS USER FORM
export const CREATE_CHECKS_USER_FORM_ROLES = 'CREATE_CHECKS_USER_FORM_ROLES';

//GET TABLE / VIEW NAME
export const ROLES_DROPDOWN_REQUEST = 'ROLES_DROPDOWN_REQUEST';
export const ROLES_DROPDOWN_SUCCESS = 'ROLES_DROPDOWN_SUCCESS';
export const ROLES_DROPDOWN_FAILURE = 'ROLES_DROPDOWN_FAILURE';

//GET TABLE / VIEW NAME
export const SECTION_DROPDOWN_REQUEST = 'SECTION_DROPDOWN_REQUEST';
export const SECTION_DROPDOWN_SUCCESS = 'SECTION_DROPDOWN_SUCCESS';
export const SECTION_DROPDOWN_FAILURE = 'SECTION_DROPDOWN_FAILURE';

// UPDATE PROPERTIES FOR MENU MASTER
export const UPDATE_ROLES_REQUEST = 'UPDATE_ROLES_REQUEST';
export const UPDATE_ROLES_SUCCESS = 'UPDATE_ROLES_SUCCESS';
export const UPDATE_ROLES_FAILURE = 'UPDATE_ROLES_FAILURE';

// FETCH SINGLE MENU
export const FETCH_SINGLE_ROLES_REQUEST = 'FETCH_SINGLE_ROLES_REQUEST';
export const FETCH_SINGLE_ROLES_SUCCESS = 'FETCH_SINGLE_ROLES_SUCCESS';
export const FETCH_SINGLE_ROLES_FAILURE = 'FETCH_SINGLE_ROLES_FAILURE';

// DELETE PROPERTIES FOR MENU MASTER
export const DELETE_ROLES_REQUEST = 'DELETE_ROLES_REQUEST';
export const DELETE_ROLES_SUCCESS = 'DELETE_ROLES_SUCCESS';
export const DELETE_ROLES_FAILURE = 'DELETE_ROLES_FAILURE';

// USERFORM RESET

export const ROLES_USERFORM_RESET = 'ROLES_USERFORM_RESET';
